import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { ActivityLogModel } from "../models";

export const logActivity = async (log: Omit<ActivityLogModel, 'id' | 'createdAt'>) => {
    try {
        await addDoc(collection(db, 'logs'), {
            ...log,
            createdAt: Date.now()
        });
    } catch (error) {
        console.error("Failed to save activity log:", error);
        // We log the error but don't throw it to prevent breaking the main flow
    }
};
